import { t } from '@/i18n';

import type { FinancialEventImpact } from '@/entities/financial-calendar';
import { IMPACT_CONFIG } from './ImpactBar';

/**
 * TRAD-2909(§K-2) — 정본: 목록 행·격자 칩·상세 패널·드로어 = HIGH 전용 텍스트 배지.
 * 3분할 바(`ImpactBar`)를 대체한다.
 *
 * 근거(designer §K-1, 운영 전수 17,038건, 2026-06-01~09-30): 어느 필터 체제에서도 바는
 * ~95%가 한 값을 그리는 상수다 — 필터 전체해제 시 LOW 94.66%(1칸), 기본필터
 * HIGH+MEDIUM 시 MEDIUM 96.37%(2칸). 행 하나가 나르는 정보량이 0.22~0.31 bit(3등급
 * 이론 최대치의 20~23%)뿐이다. 게다가 web 자체 3색 램프도 인접 등급을 못 가른다
 * (HIGH 4.31:1 / MEDIUM 3.69:1 / LOW 3.12:1 — 인접 차 1.17~1.18배, 셋 다 WCAG 4.5 미만).
 * MEDIUM/LOW/미지값은 무표시(화이트리스트 — 서버가 새 등급을 내려도 자동으로 안 그려진다).
 *
 * 🔴 스타일은 같은 행에 이미 있는 "발표완료"(confirmed) 배지 규격을 그대로 재사용한다
 * (UI 일관성 룰 1 — 신규 레이아웃 금지). web용 "중요도 배지" 전용 배색 결정은 아직 없다
 * — iOS·android의 칩+`#003366` 통일(designer T-3)은 그 두 플랫폼 사이의 정합이고,
 * designer 문서 §1-4/T-3 표에는 web 컬럼 자체가 없다. 여기서 새 색을 지어내지 않는다
 * — 필요해지면 designer 판단으로 후속 처리.
 */
export const ImportanceBadge = ({ impact }: { impact: FinancialEventImpact | null }) => {
  if (impact !== 'HIGH') return null;
  return (
    <span className="text-2xs text-muted-foreground border border-border rounded-full px-1.5">
      {t(IMPACT_CONFIG.HIGH.labelKey)}
    </span>
  );
};
